export const sectionThemeToTailwindClasses = (theme: Record<string, string>) => {



    return [
        'flex',
        'flex-wrap',
        'gap-4',
        'items-center',
        'justify-center',
        'w-full',
    ];
};

